import ScrollMagic from 'scrollmagic';

const controller = new ScrollMagic.Controller();

// 预渲染的访问地址默认是 8000，开发地址默认是8080
if (location.href.indexOf('localhost:800') > -1) {
  // 说明是打包中，需要禁用 ScrollMagic，避免重复渲染出 scrollmagic-pin-spacer
  setTimeout(() => {
    controller.destroy(true);
  }, 200);
}
export default controller;
